/**
 * @desc Our "large" loading indicator with random/rotating messages
 * @example
 * 1. Normal/whole/main page
 *    <cs-loading-component loading="myCtrl.someBool"></cs-loading-component>
 * 2. Compact w/top offset
 *    <cs-loading-component loading="myCtrl.someBool" compact="true" offset-top="50"></cs-loading-component>
 * If you need to use a static message instead of a random one, use text attribute (text="My Message")
 */
;(function () {
  'use strict'

  angular
    .module('contrast.loading')
    .directive('csLoadingComponent', ['$document', csLoadingComponent])

  function csLoadingComponent($document) {
    return {
      restrict: 'E',
      scope: {
        loading: '=',
        compact: '=',
        offsetTop: '=',
        text: '@'
      },
      replace: true,
      templateUrl: 'views/common/loading_component.html',
      link: function (scope) {
        if (
          scope.offsetTop &&
          angular.isNumber(parseInt(scope.offsetTop, 10))
        ) {
          var selector = '.loading-text-container'
          var child = angular.element($document.querySelectorAll(selector)[0])
          child.prop('style', 'top: ' + scope.offsetTop + 'px !important')
        }
      }
    }
  }
})()
